var map = {
	"./kevin-headshot-square.jpg": 852,
	"./kevin-headshot-square.webp": 491,
	"./kevin-hernandez-resume.pdf": 999,
	"./new5hark-todo-list-app.png": 172,
	"./new5hark-todo-list-app.webp": 757,
	"./social-burger-app.png": 691,
	"./social-burger-app.webp": 264,
	"./social-media-api.png": 473,
	"./social-media-api.webp": 622,
	"./stock-portfolio-analyzer-app.png": 827,
	"./stock-portfolio-analyzer-app.webp": 640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;